import Image from "next/image";
import React, { useState, useEffect } from "react";

type Props = {
  symbol: string;
};

const CurrencyImage = ({ symbol }: Props) => {
  const [iconSrc, setIconSrc] = useState("/assets/v2/sleap-logo-white.svg");

  useEffect(() => {
    const loadIcon = async (symbol: any) => {
      try {
        const icon = await import(
          `cryptocurrency-icons/svg/color/${symbol.toLowerCase()}.svg`
        );
        setIconSrc(icon.default);
      } catch (error) {
        setIconSrc(`/assets/v2/icons/currencies/${symbol.toLowerCase()}.svg`);
      }
    };

    if (symbol) {
      loadIcon(symbol);
    }
  }, [symbol]);

  return (
    <Image
      src={iconSrc}
      alt={symbol}
      width={32}
      height={32}
      quality={100}
      sizes="32px"
      className="rounded-full"
      onError={() => setIconSrc("/assets/v2/sleap-logo-white.svg")}
    />
  );
};

export default CurrencyImage;
